import { default as TreeView } from '@modul-connect/shared/components/atoms/dropdownTree/dropdownTree'
import React from 'react'
import { useTranslation } from 'react-i18next'

const OrgFilterTreeView = ({ data, onSelect, onToggle, mobile }) => {
  const {t} = useTranslation()
  return (
    <TreeView
      mobile={mobile}
      title={t('header.view')}
      inlineSearchInput
      data={data}
      onSelect={onSelect}
      onToggle={onToggle}
    />
  )
}

export default OrgFilterTreeView